import { useState, useEffect, useCallback, useMemo } from 'react';
import { Clock, CheckCircle2, XCircle, AlertCircle } from 'lucide-react';
import client from '../../api/client';
import CalendarView from '../components/CalendarView';
import { NAVY, bubbleStyle } from '../../styles/tokens';

export default function AdminCalendarPage() {
  const [events, setEvents] = useState([]);
  const [month, setMonth] = useState(new Date().getMonth());
  const [year, setYear]   = useState(new Date().getFullYear());

  const fetchCalendar = useCallback((m, y) => {
    client.get('/api/vacation/calendar', { params: { month: m + 1, year: y } })
      .then(r => setEvents(r.data))
      .catch(console.error);
  }, []);

  useEffect(() => { fetchCalendar(month, year); }, [month, year, fetchCalendar]);

  const statusCounts = useMemo(() => ({
    pending: events.filter(e => e.status === 'pending').length,
    approved: events.filter(e => e.status === 'approved').length,
  }), [events]);

  return (
    <div className="page-pad" style={{ padding: '20px 24px', maxWidth: 800, margin: '0 auto' }}>
      <h1 style={{ fontSize: 20, fontWeight: 700, color: NAVY, margin: '0 0 16px' }}>Calendario de Equipo</h1>

      {/* Status summary cards */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 8, marginBottom: 16 }}>
        {[
          { label: 'Pendientes', count: statusCounts.pending, color: '#eab308', icon: Clock },
          { label: 'Aprobadas', count: statusCounts.approved, color: '#16a34a', icon: CheckCircle2 },
        ].map(s => {
          const Icon = s.icon;
          return (
            <div key={s.label} style={{ ...bubbleStyle, padding: '10px 14px', display: 'flex', alignItems: 'center', gap: 10 }}>
              <Icon size={20} color={s.color} />
              <div>
                <div style={{ fontSize: 18, fontWeight: 700, color: s.color }}>{s.count}</div>
                <div style={{ fontSize: 11, color: '#64748b' }}>{s.label}</div>
              </div>
            </div>
          );
        })}
      </div>

      <CalendarView
        events={events}
        month={month}
        year={year}
        onMonthChange={(m, y) => { setMonth(m); setYear(y); }}
      />
    </div>
  );
}
